module.exports = __webpack_public_path__ + "img/logo-symbol@3x.34e73c9a.png";